__turbopack_context__.v({
  "sub-menu": "yGkMha_sub-menu",
  "sub-menu--expanded": "yGkMha_sub-menu--expanded",
  "sub-menu__item": "yGkMha_sub-menu__item",
  "sub-menu__item--active": "yGkMha_sub-menu__item--active",
});
